import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import PublicHeader from 'components/PublicHeader';
import IntlMessages from 'lngProvider/IntlMessages';
import FooterWrapper from 'components/Footer';
import { styled } from '@mui/material/styles';
import { getPaperStyleObject } from 'styles/Paper';

const StyledPaper = styled(Paper)((
    {
        theme
    }
    ) => {
        let paperStyle = getPaperStyleObject(theme);
        return {
            ...paperStyle.root
        };
    });

const SocialLogin = () => {
    document.title = "3M VAS - Login";
    const docUrl = new URL(document.URL);
    const docUrlParams = docUrl.searchParams;

    setTimeout(function () {
        var url = '/External/ChallengeSocial?provider=' + docUrlParams.get("provider");

        if (docUrlParams.get("path")) {
            url = url + '&path=' + docUrlParams.get("path");
        }

        if (docUrlParams.get("type")) {
            url = url + '&type=' + docUrlParams.get("type");
        }

        if (docUrlParams.get("year")) {
            url = url + '&year=' + docUrlParams.get("year");
        }

        if (docUrlParams.get("company")) {
            url = url + '&company=' + docUrlParams.get("company");
        }

        if (docUrlParams.get("role")) {
            url = url + '&role=' + docUrlParams.get("role");
        }

        if (docUrlParams.get("how")) {
            url = url + '&how=' + docUrlParams.get("how");
        }

        if (docUrlParams.get("promo")) {
            url = url + '&promo=' + docUrlParams.get("promo");
        }

        if (docUrlParams.get("terms")) {
            url = url + '&terms=' + docUrlParams.get("terms");
        }

        if (docUrlParams.get("comm")) {
            url = url + '&comm=' + docUrlParams.get("comm");
        }

        if (docUrlParams.get("returnUrl")) {
            url = url + '&returnUrl=' + docUrlParams.get("returnUrl");
        }

        if (docUrlParams.get("saveUrl")) {
            url = url + '&saveUrl=' + encodeURIComponent(docUrlParams.get("saveUrl"));
        }

        if (docUrlParams.get("utm_term")) {
            url = url + '&utm_term=' + docUrlParams.get("utm_term");
        }
        
        window.location.href = url;
    }, 3000); 

    return (
        <section>
            <PublicHeader />
            <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={12}>
                    <Grid container alignItems="center" justifyContent="center" direction="column">
                        <Grid item xs={12}>
                            <StyledPaper>
                                <Grid container alignItems="center" justifyContent="center" direction="column" spacing={4}>
                                    <Grid item xs={12}>

                                        <Typography variant="h6" className="mt-4"><IntlMessages id="socialLogin.redirecting" /> {docUrlParams.get("provider")}...</Typography>

                                    </Grid>
                                </Grid>
                            </StyledPaper>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <FooterWrapper />
        </section>
    );
};

export default SocialLogin;